export default __webpack_public_path__ + "static/media/expand-two-arrows.1fb19999.svg";